import { Modal } from "@gw/web-basic-components";
import {
  SettlementPreviewProps,
  TemplateidReq,
  TemplateidRes,
  TemplatePreviewReq,
  TemplatePreviewRes,
} from "./dto";
import TableEditor, { TableEditorConfig } from "./table-editor";
import { useRequest, apis } from "../utils";
import React, { useEffect, useMemo } from "react";
import useFormulaData from "./hooks/use-formula-data";

const Preview = ({ open, onClose, id }: SettlementPreviewProps) => {
  const [{ loading, data }, fetchTemplateDetail] = useRequest<
    TemplateidReq,
    TemplateidRes
  >(apis.settlementTmpl.show);

  const [{ loading: previewLoading, data: previdwData }, fetchPreviewData] =
    useRequest<TemplatePreviewReq, TemplatePreviewRes>(
      apis.settlementTmpl.preview
    );

  const config = useMemo(() => {
    if (data?.templateContent) {
      try {
        return JSON.parse(data.templateContent) as TableEditorConfig;
      } catch {
        return undefined;
      }
    }
    return undefined;
  }, [data?.templateContent]);

  useEffect(() => {
    if (config) {
      fetchPreviewData({
        formulaList: (config.formulas ?? []).map((i) => ({
          code: i.code,
          name: i.name,
          type: "number",
          formula: i.value.map((j) => j.value).join(""),
          isList: i.isList ?? false,
        })),
        settlementMode: data?.settlementMode,
      });
    }
  }, [config]);

  const withFormulasDataSource = useFormulaData(
    config,
    previdwData?.dataList ?? []
  );

  useEffect(() => {
    if (!id || !open) return;
    fetchTemplateDetail({ templateId: id });
  }, [open, id]);

  if (!id) {
    return null;
  }

  return (
    <Modal
      title="查看"
      width="85vw"
      open={open}
      onCancel={onClose}
      loading={loading || previewLoading}
    >
      <div className="wbuc-mx-auto wbuc-overflow-auto wbuc-p-5">
        {config && (
          <TableEditor.Viewer
            config={config}
            dataSource={withFormulasDataSource}
            className="wbuc-mx-auto wbuc-max-w-full"
          />
        )}
      </div>
    </Modal>
  );
};

export default Preview;
